module.exports = __webpack_public_path__ + "static/zedsilver-2024-f3502ab2ba6ab9ec8ee8cf77c4fa3d4f.jpg";